module.exports = __webpack_public_path__ + "img/11-min.0ee64cbd.jpg";